import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {Subscription} from "rxjs";
import { toggleLoading } from "../../../redux";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {UtilService} from "../../../shared/services";
import {Store} from "@ngrx/store";
import {LookupService, UuidService} from "../../../../services";
import {ToastrService} from "ngx-toastr";
import {SubdocService} from "../../services/subdoc/subdoc.service";
import {Router} from "@angular/router";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MatTableDataSource} from "@angular/material/table";
import {ISyndicationSubdoc} from "../../models/syndication";
import {HttpErrorResponse} from "@angular/common/http";
import {DeleteConfirmationModalComponent} from "../../../shared/components";

@Component({
  selector: 'app-deal-subscription-subdoc-edit-modal',
  templateUrl: './deal-subscription-subdoc-edit-modal.component.html',
  styleUrls: ['./deal-subscription-subdoc-edit-modal.component.scss']
})
export class DealSubscriptionSubdocEditModalComponent implements OnInit {
  userSource: MatTableDataSource<ISubdocUser> = new MatTableDataSource();
  fileSource: MatTableDataSource<ISubdocFile> = new MatTableDataSource();

  userColumns = ['name', 'email', 'profile', 'sigStatus'];
  fileColumns = ['name', 'size', 'uploadedBy', 'uploadedOn', 'actions'];

  subDoc!: ISubdocResponse;


  // Are any files uploaded or deleted? then refresh the syndication list when closing the form
  isModified: boolean = false;
  allowStatusChange: boolean = false;

  subDocStatusFg : FormGroup = new FormGroup({
    status: new FormControl('', Validators.required)
  });

  form = new FormGroup({
    status: new FormControl(),
    subDocAccessUser: new FormControl(),
    uploadedFiles: new FormControl(),
  });

  @ViewChild('fileUpload') private fileInput: ElementRef | undefined;

  constructor(
    public util: UtilService,
    private store: Store,
    private uuid: UuidService,
    private toastr: ToastrService,
    private subDocService: SubdocService,
    private router: Router,
    private dialog: MatDialog,
    public lookupService: LookupService,
    public dialogRef: MatDialogRef<DealSubscriptionSubdocEditModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { subdoc: ISyndicationSubdoc }) {

  }


  ngOnInit(): void {
    this.getSubdoc();
  }

  getSubdoc() {
    console.log("Fetching SubDoc...");
    this.store.dispatch(toggleLoading({loading: true}));
    this.subDocService.getSubdocById(this.data.subdoc.id).subscribe({
      next: (subdoc: ISubdocResponse) => {
        console.log("subDoc", subdoc);
        this.subDoc = subdoc;
        this.subDocStatusFg.patchValue(subdoc);
        this.userSource = new MatTableDataSource(subdoc.subDocAccessUser);
        this.fileSource = new MatTableDataSource(subdoc.uploadedFiles);
        this.store.dispatch(toggleLoading({loading: false}));
      }, error: err => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Unable to get subdocs!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  saveStatus() {
    console.log("Updating SubDoc Status...", this.subDocStatusFg.value);
    this.store.dispatch(toggleLoading({loading: true}));
    this.subDocService.updateSubdocStatus(this.subDoc.id, this.subDocStatusFg.value).subscribe({
      next: (res: any) => {
        this.getSubdoc();
        this.isModified = true;
        this.toastr.success("Status Updated!", $localize`:@@companyName:Rondeivu`);
      }, error: err => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Unable to update subdoc status!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  downloadAll() {
    this.store.dispatch(toggleLoading({loading: true, message: "This operation may take a few seconds!"}));
    this.subDocService.downloadDocumentZip(this.data.subdoc.id).subscribe({
      next: (res: any) => {
        let filename = 'download.zip';
        let blob: Blob = res as Blob;
        let a = document.createElement('a');
        a.download = filename;
        a.href = window.URL.createObjectURL(blob);
        a.click();
        this.store.dispatch(toggleLoading({loading: false}));
      },
      error: (err: any) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Unable to download files!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  downloadSubdoc(element: ISubdocFile) {
    this.store.dispatch(toggleLoading({loading: true, message: "This operation may take a few seconds!"}));
    this.subDocService.downloadFile(element.id).subscribe({
      next: (res: any) => {
        let filename = element.filename;
        let blob: Blob = res as Blob;
        let a = document.createElement('a');
        a.download = filename;
        a.href = window.URL.createObjectURL(blob);
        a.click();
        this.store.dispatch(toggleLoading({loading: false}));
      },
      error: (err: any) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Unable to download file!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  deleteSubdocFile(element: ISubdocFile) {
    this.dialog.open(DeleteConfirmationModalComponent, {
      height: 'auto',
      width: 'auto',
      data: {
        file: element
      },
      disableClose: true
    })
    .afterClosed().subscribe(result => {
      if (!!result) {
        this.store.dispatch(toggleLoading({loading: true}));
        this.subDocService.deleteFile(element.id).subscribe({
          next: (res: any) => {
            this.getSubdoc();
            // this.store.dispatch(toggleLoading({loading: false}));
            this.toastr.success("File Deleted", $localize`:@@companyName:Rondeivu`);
          }, error: (err: any) => {
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastr.warning("Unable to delete document!", $localize`:@@companyName:Rondeivu`);
          }
        });
      }
    });
  }

  /**
   * Action for adding a new file
   * @param event
   */
  addDocuments(event: any) {
    // console.log(event);
    if (!!event && !!event.target && !!event.target.files[0]) {
      this.uploadSupportingFile(event.target.files[0]);
      if (!!this.fileInput) {
        this.fileInput.nativeElement.value = '';
      }
    }
  }

  private uploadSupportingFile(file: any) {
    this.store.dispatch(toggleLoading({loading: true}));
    this.subDocService.uploadSubdocDocument(this.subDoc.id, file).subscribe({
      next: (file: ISubdocFile) => {
        this.subDoc.uploadedFiles.push(file);
        this.fileSource = new MatTableDataSource(this.subDoc.uploadedFiles);
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.success("File Uploaded!", $localize`:@@companyName:Rondeivu`);
      }, error: (err: HttpErrorResponse) => {
        console.log(err);
        this.store.dispatch(toggleLoading({loading: false}));

        if (err.status === 413) {
          // file too large
          this.toastr.error("File too large!", $localize`:@@companyName:Rondeivu`);
        }
        else {
          this.toastr.error("Unable to upload file!", $localize`:@@companyName:Rondeivu`);
        }
      }
    });
  }

}


interface ISubdocResponse {
  amount: number;
  created: string;
  dealId: string;
  entityName: string;
  entityType: string;
  id: string;
  showInvestorFillDataAndApproveButton: boolean;
  showIssuerApprovalButton: boolean;
  showRondeivuApprovalButton: boolean;
  status: string;
  subDocAccessUser: ISubdocUser[];
  subscriptionAmount: number;
  subscriptionDate: string;
  subscriptionId: string;
  uploadedFiles: ISubdocFile[];
}

interface ISubdocUser {
  id: string;
  fullName: string;
  email: string;
  profile: string;
  emailStatus: string;
  signatureStatus: string;
  signedOn: Date | null;
  sortOrder: number;
  accessType: string;
}

interface ISubdocFile {
  id: string;
  filename: string;
  fileSize: string;
  uploadedBy: {
    id: string;
    firstName: string;
    lastName: string;
    imageUrl: string;
    created: string;
  };
  created: string;
}


